var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTraitsniperIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4564 5H6.1525L4 8.91314L12.3038 18.4793L20.6076 8.91314L18.4564 5ZM17.8894 6.05353L19.1505 8.34617H16.8851L17.8894 6.05353ZM16.8164 6.00424L15.8965 8.10223L13.5986 6.00424H16.8164ZM14.6742 8.33967H9.93331L12.3038 6.17551L14.6742 8.33967ZM11.0102 6.00424L8.71239 8.10223L7.79249 6.00424H11.0102ZM6.71819 6.05353L7.72243 8.34617H5.45705L6.71819 6.05353ZM5.70876 9.3491H8.16227L10.6664 15.058L5.70876 9.3491ZM9.25863 9.3491H15.3489L12.3038 16.297L9.25863 9.3491ZM13.9412 15.058L16.4453 9.3491H18.8975L13.9412 15.058Z",
    fill: "#723BCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraitsniperIcon);
export default __webpack_public_path__ + "static/media/traitsniper_icon.5019d098.svg";
export { ForwardRef as ReactComponent };